import { asError } from './asError';

const fbqPromise = typeof window === 'undefined' ? null : new Promise<void>((resolve) => { window.fbqResolvePromise = resolve; });

// Called after hydration. A consent-gated pixel is skipped here and initialized by
// injectConsentScripts once marketing consent is approved.
export const initFacebookPixel = () => {
  if (window.popmenuInitFbq && !window.popmenuInitFbq.requiresConsent) {
    window.popmenuInitFbq();
  }
};

export const trackFacebookEvent = async (eventName: string, options: Record<string, unknown> | null = null) => {
  if (typeof window === 'undefined') {
    console.error('the function trackFacebookEvent should never be called during SSR.');
    return false;
  }
  try {
    if (!window.fbq) {
      // Without marketing consent the pixel may never initialize, so drop the event
      // rather than queue it to fire after a later opt-in.
      if (window.popmenuInitFbq?.requiresConsent) {
        return false;
      }
      await fbqPromise;
    }

    if (typeof window.fbq === 'function') {
      if (options) {
        window.fbq('track', eventName, options);
      } else {
        window.fbq('track', eventName);
      }
    }
    return true;
  } catch (err) {
    // Prevent FB pixel errors from ever crashing the page
    console.warn(`[POPMENU] FB Pixel Error: ${asError(err).toString()}`);
    return false;
  }
};
